import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83a2ef7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, null, -1))
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "mt-2" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  class: "mt-2",
  style: {"display":"flex","flex-direction":"row","align-items":"center"}
}
const _hoisted_18 = { style: {"display":"flex","flex-direction":"row","align-items":"center"} }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_TreeForParams = _resolveComponent("TreeForParams")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TreeForParams, {
      value: $data.paramsTree,
      class: "customTreeView"
    }, {
      number: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            innerHTML: slotProps.node.label
          }, null, 8, _hoisted_3),
          (slotProps.node?.description)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-rounded p-button-text",
                icon: "pi pi-question-circle",
                onClick: ($event: any) => ($data.xapi.xShowModal({text: slotProps.node?.description}))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_InputNumber, {
          modelValue: $data.paramsValues[slotProps.node.key],
          "onUpdate:modelValue": ($event: any) => (($data.paramsValues[slotProps.node.key]) = $event),
          allowEmpty: false,
          disabled: slotProps.node.disabled,
          class: "w-full mt-2 mb-2",
          mode: "decimal",
          style: {"min-width":"600px"}
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
      ]),
      string: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            innerHTML: slotProps.node.label
          }, null, 8, _hoisted_5),
          (slotProps.node?.description)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-rounded p-button-text",
                icon: "pi pi-question-circle",
                onClick: ($event: any) => ($data.xapi.xShowModal({text: slotProps.node?.description}))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_InputText, {
          modelValue: $data.paramsValues[slotProps.node.key],
          "onUpdate:modelValue": ($event: any) => (($data.paramsValues[slotProps.node.key]) = $event),
          disabled: slotProps.node.disabled,
          class: "w-full mt-2 mb-2",
          style: {"min-width":"600px"},
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
      ]),
      button: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            innerHTML: slotProps.node?.label
          }, null, 8, _hoisted_7),
          (slotProps.node?.description)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-rounded p-button-text",
                icon: "pi pi-question-circle",
                onClick: ($event: any) => ($data.xapi.xShowModal({text: slotProps.node?.description}))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        (slotProps.node?.buttonOptions?.action === 'GET')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: _normalizeClass(slotProps.node?.buttonOptions?.buttonClass+ ' mt-2'),
              disabled: slotProps.node?.disabled,
              label: slotProps.node?.buttonLabel,
              "icon-pos": "left",
              onClick: ($event: any) => ($options.get(slotProps.node.buttonOptions?.url))
            }, null, 8, ["class", "disabled", "label", "onClick"]))
          : _createCommentVNode("", true),
        (slotProps.node?.action === 'UPLOAD')
          ? (_openBlock(), _createBlock(_component_FileInput, {
              key: 1,
              accept: slotProps.node?.options?.accept,
              class: _normalizeClass(slotProps.node?.buttonClass+ ' mt-2 mr-2'),
              label: slotProps.node?.buttonLabel,
              multiple: slotProps.node?.options?.multiple === true,
              inline: "",
              onFileChange: (file, component) => $options.upload(file, component, slotProps.node)
            }, null, 8, ["accept", "class", "label", "multiple", "onFileChange"]))
          : _createCommentVNode("", true)
      ]),
      buttons: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", {
            innerHTML: slotProps.node?.label
          }, null, 8, _hoisted_9),
          (slotProps.node?.description)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-rounded p-button-text",
                icon: "pi pi-question-circle",
                onClick: ($event: any) => ($data.xapi.xShowModal({text: slotProps.node?.description}))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.node?.buttons, (button) => {
          return (_openBlock(), _createElementBlock("span", null, [
            (button?.action === 'GET')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: _normalizeClass(button?.buttonClass+ ' mt-2 mr-2'),
                  disabled: button?.disabled,
                  label: button?.buttonLabel,
                  "icon-pos": "left",
                  onClick: ($event: any) => ($options.get(button?.url))
                }, null, 8, ["class", "disabled", "label", "onClick"]))
              : _createCommentVNode("", true),
            (button?.action === 'UPLOAD')
              ? (_openBlock(), _createBlock(_component_FileInput, {
                  key: 1,
                  accept: button?.options?.accept,
                  class: _normalizeClass(button?.buttonClass+ ' mt-2 mr-2'),
                  label: button?.buttonLabel,
                  multiple: button?.options?.multiple === true,
                  inline: "",
                  onFileChange: (file, component) => $options.upload(file, component, button)
                }, null, 8, ["accept", "class", "label", "multiple", "onFileChange"]))
              : _createCommentVNode("", true)
          ]))
        }), 256)),
        _hoisted_10
      ]),
      password: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", {
            innerHTML: slotProps.node.label
          }, null, 8, _hoisted_12),
          (slotProps.node?.description)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-rounded p-button-text",
                icon: "pi pi-question-circle",
                onClick: ($event: any) => ($data.xapi.xShowModal({text: slotProps.node?.description}))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Password, {
          modelValue: $data.paramsValues[slotProps.node.key],
          "onUpdate:modelValue": ($event: any) => (($data.paramsValues[slotProps.node.key]) = $event),
          disabled: slotProps.node.disabled,
          toggleMask: true,
          autocomplete: "new-password",
          class: "w-full mt-2 mb-2 password",
          mediumLabel: "Средний",
          promptLabel: "Введите пароль",
          strongLabel: "Стойкий",
          style: {"min-width":"600px"},
          weakLabel: "Слабый"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
      ]),
      enum: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", {
            innerHTML: slotProps.node.label
          }, null, 8, _hoisted_14),
          (slotProps.node?.description)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-rounded p-button-text",
                icon: "pi pi-question-circle",
                onClick: ($event: any) => ($data.xapi.xShowModal({text: slotProps.node?.description}))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Dropdown, {
          modelValue: $data.paramsValues[slotProps.node.key],
          "onUpdate:modelValue": ($event: any) => (($data.paramsValues[slotProps.node.key]) = $event),
          disabled: slotProps.node.disabled,
          options: slotProps.node?.enumTypes,
          placeholder: slotProps.node.placeHolder,
          autofocus: "",
          class: "w-full mt-2 mb-2",
          "option-label": "title",
          "option-value": "val",
          style: {"min-width":"600px"}
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "options", "placeholder"])
      ]),
      "multi-enum": _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", {
            innerHTML: slotProps.node.label
          }, null, 8, _hoisted_16),
          (slotProps.node?.description)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-rounded p-button-text",
                icon: "pi pi-question-circle",
                onClick: ($event: any) => ($data.xapi.xShowModal({text: slotProps.node?.description}))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_MultiSelect, {
          modelValue: $data.paramsValues[slotProps.node.key],
          "onUpdate:modelValue": ($event: any) => (($data.paramsValues[slotProps.node.key]) = $event),
          disabled: slotProps.node.disabled,
          filter: true,
          "max-selected-labels": 1,
          options: slotProps.node?.options,
          placeholder: slotProps.node.placeHolder,
          autofocus: "",
          class: "w-full",
          "option-label": "title",
          "option-value": "val",
          "selected-items-label": "{0} элементов выбрано",
          style: {"min-width":"500px"}
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "options", "placeholder"])
      ]),
      bool: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_Checkbox, {
            modelValue: $data.paramsValues[slotProps.node.key],
            "onUpdate:modelValue": ($event: any) => (($data.paramsValues[slotProps.node.key]) = $event),
            binary: true,
            disabled: slotProps.node.disabled
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              innerHTML: slotProps.node.label
            }, null, 8, _hoisted_19),
            _hoisted_20,
            (slotProps.node.description)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-rounded p-button-text",
                  icon: "pi pi-question-circle",
                  onClick: ($event: any) => ($data.xapi.xShowModal({text: slotProps.node.description}))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      custom: _withCtx((slotProps) => [
        _createElementVNode("div", {
          class: "mb-3",
          style: {"text-decoration":"underline"},
          innerHTML: slotProps.node.label
        }, null, 8, _hoisted_21),
        _createElementVNode("div", null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(slotProps.node.component), {
            modelValue: $data.paramsValues[slotProps.node.key],
            "onUpdate:modelValue": ($event: any) => (($data.paramsValues[slotProps.node.key]) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
        ])
      ]),
      default: _withCtx((slotProps) => [
        _createElementVNode("div", {
          style: {"font-weight":"bold","text-decoration":"underline"},
          innerHTML: slotProps.node.label
        }, null, 8, _hoisted_22)
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_Button, {
      class: "p-button-success p-button-outlined mt-5",
      label: "Сохранить",
      onClick: $options.save
    }, null, 8, ["onClick"])
  ]))
}